import React from 'react';
import './DashboardType9.scss';
import {useNavigate} from "react-router-dom";

const DashboardType9 = () => {

  const navigateTo = useNavigate();

  return (
    <section className={"dashboard-type9"}>

      <div className={"row-button"}>
        <button className={"dashboard-type9_btn"} onClick={() => navigateTo("/transfer-learner")}>
          انتقال زبان آموز
        </button>
      </div>

    </section>
  );
};

export default DashboardType9;